import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback, useRef } from 'react';
import { isFunction } from "../../utils/is-function";
import { Popover } from "../Popover";
import { MenuList } from "./MenuList";
/**
 * Menu
 *
 * A menu composes Popover, and shows a keyboard
 * navigable list of items which possibly have
 * submenus.
 */

export function Menu(_ref) {
  var minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      width = _ref.width,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      initialFocusRef = _ref.initialFocusRef,
      other = _objectWithoutProperties(_ref, ["minWidth", "maxWidth", "width", "children", "className", "content", "initialFocusRef"]);

  var menuListRef = useRef();
  var renderContent = useCallback(function (props) {
    return /*#__PURE__*/React.createElement(MenuList, {
      minWidth: minWidth,
      maxWidth: maxWidth,
      width: width,
      ref: menuListRef
    }, isFunction(content) ? content(props) : content);
  }, [content, maxWidth, minWidth, width]);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    initialFocusRef: initialFocusRef !== null && initialFocusRef !== void 0 ? initialFocusRef : menuListRef,
    content: renderContent,
    className: className
  }, other), children);
}